import React from 'react';
import { AdvertisedCarType } from 'types/car';
import CarFeed from 'components/CarFeed';

export const CarFeedField: React.FC<AdvertisedCarType> = (props) => {
	return <CarFeed advertisedCar={props} />;
};
